import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import ErrorPage from '../errorPage/errorPage';

const HeroBody = ({ activeLink, isMobileMenuOpen }: { activeLink: string, isMobileMenuOpen: boolean }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const validPaths = ['Home', 'About', 'Projects', 'Services', 'Contacts'];

  return (
    <div className="heroBody">
      {activeLink === 'Home' &&
        <>
          <h1 className="hero-title">Building the Future, Restoring the Past</h1>
          <p className="hero-text">
            We specialize in residential, commercial, and industrial construction, delivering quality craftsmanship and innovative solutions to bring your vision to life.
          </p>
          <div className="buttons-container">
            <button className="learn-more-button" onClick={() => {
              navigate('/About');
              window.scrollTo({ top: 0 })
            }}
            >Learn More</button>
            <div className="contact-button-container" >
              <svg className="contact-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.23 15.76L16.69 15.47C16.3913 15.4349 16.0886 15.468 15.8046 15.5667C15.5205 15.6654 15.2625 15.8273 15.05 16.04L13.21 17.88C10.3712 16.4362 8.06378 14.1288 6.61999 11.29L8.47 9.44001C8.89999 9.01001 9.10999 8.41001 9.03999 7.80001L8.74999 5.28001C8.6933 4.79219 8.45919 4.34225 8.09223 4.01586C7.72527 3.68947 7.2511 3.50943 6.76 3.51001H5.03C3.9 3.51001 2.95999 4.45001 3.02999 5.58001C3.55999 14.12 10.39 20.94 18.92 21.47C20.05 21.54 20.99 20.6 20.99 19.47V17.74C21 16.73 20.24 15.88 19.23 15.76Z" />
              </svg>
              <div className="contact-button" onClick={() => {
                navigate('/Contacts');
                window.scrollTo({ top: 0 })
              }}>Contact Us</div>
            </div>
          </div>
        </>
      }
      {activeLink === 'About' &&
        <NavigatedPages from={'Home'} page={activeLink} />
      }
      {(activeLink === 'Projects' && !location.pathname.split('/')[2]) &&
        <NavigatedPages from={'Home'} page={activeLink} />
      }
      {(location.pathname.split('/')[1] === 'Projects' && location.pathname.split('/')[2]) && (
        <NavigatedPages from="Projects" page={(location.pathname.split('/')[2] || 'Home').replace(/-/g, ' ')} />
      )}
      {activeLink === 'Services' &&
        <NavigatedPages from={'Home'} page={activeLink} />
      }
      {activeLink === 'Contacts' &&
        <NavigatedPages from={'Home'} page={'Contact Us'} />
      }
      {(location.pathname.split('/')[1] && (!validPaths.includes(location.pathname.split('/')[1]))) &&
        <ErrorPage />
      }
      {!isMobileMenuOpen &&
        <div
          className="scroll-arrow"
          onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
        >
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M12 19L5 12M12 19L19 12" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      }
    </div>
  )
}

export default HeroBody;

const NavigatedPages = ({ from, page }: { from: string, page: string }) => {
  return (
    <>
      <h1 className="hero-title">{page}</h1>
      <div className="nav-indicator">
        <div className="from">{from}</div>
        <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.4999 5.91643L2.16067 10.2557C2.01177 10.4046 1.83097 10.479 1.61826 10.479C1.40556 10.479 1.22476 10.4046 1.07586 10.2557L0.373926 9.52182C0.22503 9.37292 0.150583 9.19212 0.150583 8.97942C0.150583 8.76671 0.22503 8.58591 0.373926 8.43701L3.43691 5.37402L0.373926 2.31104C0.22503 2.16214 0.150583 1.98134 0.150583 1.76863C0.150583 1.55592 0.22503 1.37512 0.373926 1.22623L1.07586 0.492386C1.22476 0.343491 1.40556 0.269043 1.61826 0.269043C1.83097 0.269043 2.01177 0.343491 2.16067 0.492386L6.4999 4.83162C6.6488 4.98051 6.72325 5.16132 6.72325 5.37402C6.72325 5.58673 6.6488 5.76753 6.4999 5.91643ZM12.6259 4.83162C12.7748 4.98051 12.8492 5.16132 12.8492 5.37402C12.8492 5.58673 12.7748 5.76753 12.6259 5.91643L8.28665 10.2557C8.13775 10.4046 7.95695 10.479 7.74424 10.479C7.53153 10.479 7.35073 10.4046 7.20184 10.2557L6.4999 9.52182C6.35101 9.37292 6.27656 9.19212 6.27656 8.97942C6.27656 8.76671 6.35101 8.58591 6.4999 8.43701L9.56289 5.37402L6.4999 2.31104C6.35101 2.16214 6.27656 1.98134 6.27656 1.76863C6.27656 1.55592 6.35101 1.37512 6.4999 1.22623L7.20184 0.492386C7.28692 0.428574 7.372 0.375397 7.45709 0.332855C7.56344 0.290314 7.65916 0.269043 7.74424 0.269043C7.85059 0.269043 7.94631 0.290314 8.0314 0.332855C8.13775 0.375397 8.22283 0.428574 8.28665 0.492386L12.6259 4.83162Z" fill="#D2C165" />
        </svg>
        <div className="to">{page}</div>
      </div>
    </>
  )
}
